export enum PasswordCriteria {
  containsUpperAndLowerLetters,
  containsNumberOrSpecialCharacter,
  sufficientLength,
}

export const validatePassword = (password: string) => {
  const unmetCriteria: PasswordCriteria[] = []

  if (!(hasUpperCase(password) && hasLowerCase(password))) {
    unmetCriteria.push(PasswordCriteria.containsUpperAndLowerLetters)
  }
  if (!(hasNumber(password) || hasSpecialCharacters(password))) {
    unmetCriteria.push(PasswordCriteria.containsNumberOrSpecialCharacter)
  }
  if (!isPasswordValidLength(password)) {
    unmetCriteria.push(PasswordCriteria.sufficientLength)
  }

  return {
    unmetCriteria,
  }
}

function isPasswordValidLength(password: string) {
  return !!password && password.length >= 8
}

function hasNumber(password: string) {
  return /[0-9]/.test(password)
}

function hasSpecialCharacters(password: string) {
  // Special Characters refers to 35 ASCII special characters not Unicode characters
  // eslint-disable-next-line no-useless-escape
  return /[ -/:-@\[-`{-~]/.test(password) // a group of 4 inclusive ranges: from space to / ,from : to @ ,from [ to `,from { to ~
}

function hasUpperCase(password: string) {
  return /[A-Z]/.test(password)
}

function hasLowerCase(password: string) {
  return /[a-z]/.test(password)
}
